app.component("allergyForm", {
	templateUrl: "app/src/js/components/medications/AllergyForm.html",
	controller: "allergyFormController",
	bindings: {
		patientId: "=",
	},
});

app.controller("allergyFormController", [
	"$scope",
	"$modal",
    "$filter",
    "Session",
	"AllergyAPI",
	"ShareData",
	function ($scope, $modal,$filter,Session,AllergyAPI,ShareData) {

        this.$onInit = function () {
            $scope.causative_agents_noResults = false;
            $scope.causative_agents_loading = false;
            $scope.type_of_reaction_noResults = false;
            $scope.type_of_reaction_loading = false;

            $scope.AllergyAPI = AllergyAPI;
			$scope.formData = {
				causative_agents: "",
                causative_agents_search_term: "",
				causative_agents_object: null,
                reaction_type: "",
                reaction_type_search_term: "",
				reaction_type__object: null,
			};
            $scope.allergyList = [];
			// Unknown until the lookup succeeds - never show "no known drug allergies" by default.
			$scope.NO_DRUG_ALLERGIES = {value: null};
			fetchPatientAllergy();
		};

		$scope.warn = false;
		$scope.isSubmitting = false;

		$scope.$watch(
			"$ctrl.allergyForm",
			function (newValue, oldValue) {
				if($scope.$ctrl.allergyForm &&
					$scope.$ctrl.allergyForm.severity && 
					$scope.$ctrl.allergyForm.certainty &&
					$scope.formData.causative_agents &&
					$scope.formData.reaction_type
					){
						$scope.warn = true;
					}else{
						$scope.warn = false;
					}
			},
			true
		);

		$scope.$watch(
			"formData",
			function (newValue, oldValue) {
				if($scope.$ctrl.allergyForm &&
					$scope.$ctrl.allergyForm.severity && 
					$scope.$ctrl.allergyForm.certainty &&
					$scope.formData.causative_agents &&
					$scope.formData.reaction_type
					){
						$scope.warn = true;
					}else{
						$scope.warn = false;
					}
			},
			true
		);

		$scope.renderLastOccurrence = function(lastOccurrence) {
			return lastOccurrence ? `(${lastOccurrence})` : '';
		}
      
		$scope.checkboxModel = {};

        $scope.Session = Session;
		$scope.SD = ShareData;
        $scope.causativeAgentsOnSelect = function(item, model, label, event) {
			$scope.formData.causative_agents_object = item;
        }

        

        $scope.reactionOnSelect = function(item, model, label, event) {
			$scope.formData.reaction_type__object = item;
        }


        $scope.fetchCausativeAgents = function (value, theForm) {
            $scope.causative_agents_loading = true;
            return new Promise((resolve, reject) => {
                searchAllergy(value, resolve, reject)
            })
        };

        $scope.fetchReaction = function (value, theForm) {
            $scope.type_of_reaction_loading = true;
            return new Promise((resolve, reject) => {
                searchReaction(value, resolve, reject)
            })
        };

		$scope.NKDAOnChange = function(){
			if($scope.NO_DRUG_ALLERGIES.value == undefined){
				return;
			}
			$scope.AllergyAPI.isProcessing = true;
			$scope.AllergyAPI.saveNKDA($scope.$ctrl.patientId, $scope.NO_DRUG_ALLERGIES.value).then(function(resp){
				if(!$scope.NO_DRUG_ALLERGIES.value){
					$scope.AllergyAPI.getAllergy($scope.$ctrl.patientId).then(function(resp){
						$scope.allergyList = resp.data;
					},function(err){
						console.log(err && err.status)
					});
				}
				
			},function(err){
				console.log(err && err.status);
			}).then(function () {
				$scope.AllergyAPI.isProcessing = false;
			})
		}

		$scope.hasActiveAllergy = function () {
			return $scope.allergyList.some(t=>t.status === 'ACTIVE');
		}

		$scope.isFieldRequired = function () {
			if($scope.NO_DRUG_ALLERGIES.value){
				return false;
			}
			return !$scope.allergyList.some(t=>t.status ===  'ACTIVE');
		}


        function fetchPatientAllergy() {
			$scope.AllergyAPI.isProcessing = true;
			$scope.AllergyAPI.getNKDA($scope.$ctrl.patientId).then(function(resp){
				if(!resp.data.no_known_drug_allergies){
					$scope.AllergyAPI.getAllergy($scope.$ctrl.patientId).then(function(resp){
						$scope.allergyList = resp.data;
						$scope.SD.setAllergies($scope.$ctrl.patientId, resp.data);
					},function(err){
						console.log(err && err.status)
					}).then(function () {
						$scope.AllergyAPI.isProcessing = false;
						$scope.NO_DRUG_ALLERGIES.value = resp.data.no_known_drug_allergies;
					})
				}else{
					$scope.AllergyAPI.isProcessing = false;
					$scope.NO_DRUG_ALLERGIES.value = true;
				}
			},function(err){
				$scope.AllergyAPI.isProcessing = false;
			})
        }
		


		function searchAllergy(terms, resolve, reject) {
			let result = [];
            $scope.causative_agents_noResults = false;
			$scope.AllergyAPI.searchAllergy(terms,'CAUSATIVE_AGENT')
				.then(
					function (resp) {
						if (resp.data) {
							result=resp.data;
                            $scope.formData.causative_agents_search_term = terms;
							resolve(result)
						}
					},
					function (err) {
						console.log(err && err.status)
                        $scope.causative_agents_noResults = true;
                        result = [];
						reject(err)
					}
				).then(function () {
					$scope.causative_agents_loading = false;
				})
		}

        function searchReaction(terms, resolve, reject) {
			let result = [];
            $scope.type_of_reaction_noResults = false;
			$scope.AllergyAPI.searchAllergy(terms,'REACTION')
				.then(
					function (resp) {
						if (resp.data) {
							result=resp.data;
                            $scope.formData.reaction_type_search_term = terms;
							resolve(result)
						}
					},
					function (err) {
						console.log(err && err.status)
                        $scope.type_of_reaction_noResults = true;
                        result = [];
						reject(err)
					}
				).then(function () {
					$scope.type_of_reaction_loading = false;
				})
		}

		$scope.removeAllergy = function (patient_allergy_id) {
			$scope.AllergyAPI.isProcessing = true;

			return $scope.AllergyAPI.inactivatePatientAllergy($scope.$ctrl.patientId, patient_allergy_id)
				.then(function (resp) {
					$scope.allergyList = $scope.allergyList.filter(item => item.patient_allergy_id !== patient_allergy_id);
				})
				.catch(function (err) {
					console.log(err && err.status);
					$scope.serverErrorModal = $modal({
						scope: $scope,
						templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
						show: true,
						title: "Error removing allergy",
					});
				})
				.finally(function () {
					fetchPatientAllergy();
				});
		};

		$scope.today = new Date();
	
	

		$scope.SEVERITY = [
			{ name: "Mild", value: "MILD" },
			{ name: "Moderate", value: "MODERATE" },
			{ name: "Severe", value: "SEVERE" },
			// { name: "Life threatening", value: "life_threatening" },
			{ name: "Fatal", value: "FATAL" },
		];

		$scope.CERTAINTY = [
			{ name: "Unlikely", value: "UNLIKELY" },
			{ name: "Likely", value: "LIKELY" },
			{ name: "Certain", value: "CERTAIN" },
			// { name: "Confirmed by challenge testing", value: "confirmed" },
		]

		$scope.removeAllergyPopover = {
			content: "Delete"
		};

		$scope.clearIfInvalid = function (inputType) {
			if (inputType === 'CAUSATIVE') {
				// If they didn't click a suggestion, the object remains null
				if (!$scope.formData.causative_agents_object) {
					$scope.formData.causative_agents = ""; // Clear the text
				}
			} else if (inputType === 'REACTION') {
				if (!$scope.formData.reaction_type__object) {
					$scope.formData.reaction_type = ""; // Clear the text
				}
			}
		};

		$scope.addAllergy = function (causative_agents, severity, certainty, type_of_reaction, first_experienced, reaction_details) {
			if (causative_agents == null || severity == null || certainty == null || type_of_reaction == null) {
				return;
			}

			// Guard against double submission: ignore further clicks while the add is
			// in flight (the button is also disabled until it resolves).
			if ($scope.isSubmitting) {
				return;
			}

			var lname = $scope.Session.user.lastName || "";
			var fname = $scope.Session.user.firstName || "";
			const fullName = fname + " " + lname;

			const allergyData = {
				date_of_onset: $filter("date")(new Date(), "yyyy-MM-dd"),
				// Optional field: send nothing rather than new Date(null), which is 1970-01-01.
				date_of_last_occurrence: first_experienced ? $filter("date")(new Date(first_experienced), "yyyy-MM-dd") : null,
				asserter: fullName,
				comment: reaction_details,
				causative_agent_concept: causative_agents,
				reaction_concept: type_of_reaction,
				severity,
				certainty,
			}

			$scope.isSubmitting = true;
			$scope.AllergyAPI.isProcessing = true;
			$scope.AllergyAPI.addAllergy($scope.$ctrl.patientId, allergyData).then(function (resp) {
				resetAllergyForm();
				fetchPatientAllergy();
			}, function (err) {
				$scope.serverErrorModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
					show: true,
					title: "CatTrax has encountered an error",
				});
				console.log(err && err.status)
			}).then(function () {
				$scope.AllergyAPI.isProcessing = false;
				$scope.isSubmitting = false;
			})
		};

		// Only cleared once the allergy is saved, so a failed add keeps what was entered.
		function resetAllergyForm() {
			$scope.$ctrl.allergyForm.causative_agents = null;
			$scope.$ctrl.allergyForm.severity = null;
			$scope.$ctrl.allergyForm.certainty = null;
			$scope.$ctrl.allergyForm.type_of_reaction = null;
			$scope.$ctrl.allergyForm.first_experienced = null;
			$scope.$ctrl.allergyForm.reaction_details = null;
			$scope.formData = {
				causative_agents: "",
				causative_agents_search_term: "",
				causative_agents_object: null,
				reaction_type: "",
				reaction_type_search_term: "",
				reaction_type__object: null,
			};
			$scope.allergyForm.$setPristine();
		}

		$scope.acceptAllergy = function (row) {
			$scope.AllergyAPI.isProcessing = true;

			var allergyObj = angular.copy(row);
			allergyObj.is_human_verified = "VERIFIED";

			$scope.AllergyAPI.updateAllergy($scope.$ctrl.patientId, row.patient_allergy_id, allergyObj)
				.then(function () {
					$scope.AllergyAPI.isProcessing = false;
					fetchPatientAllergy();
				},
					function (err) {
					$scope.AllergyAPI.isProcessing = false;
					console.log(err && err.status);
				});
		};

		$scope.rejectAllergy = function (row) {
			$scope.AllergyAPI.isProcessing = true;

			var allergyObj = angular.copy(row);
			allergyObj.is_human_verified = "REJECTED";

			$scope.AllergyAPI.updateAllergy($scope.$ctrl.patientId, row.patient_allergy_id, allergyObj)

				.then(function () {
					$scope.AllergyAPI.isProcessing = false;
					fetchPatientAllergy();
				},
					function (err) {
					$scope.AllergyAPI.isProcessing = false;
					console.log(err && err.status);
				});
		};
	},
]);